//import { Suspense } from "react";
import React, { Suspense, useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import "./theme.css"; // Import the theme styles
import { PublicClientApplication } from "@azure/msal-browser";
import { ROUTES } from "./config/routes";
import { CustomNavigationClient } from "./utils/navigationClient";
import { APP_SETTINGS } from "./config/config";
import Layout from "./layout/index";
import RoleBasedRouting from "./components/role-based-routing";
import AccessDenied from "./pages/access-denied";
import LoadingScreen from "./components/loading-screen";
import { componentMapping } from "./config/lazyRoutes";
import Import from "./pages/admin/import";
import { useAppDispatch, useAppSelector } from "./hooks/redux";
import NotificationDialog from "./components/dialog";
import { clearAllSelectedItems } from "./store/reducers/inventorySelectionSlice";

const LAB_INVENTORY_GLOBAL_SEARCH_KEY = "labInventoryGlobalSearch";

export const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigationClient = new CustomNavigationClient(navigate);
  const msalInstance = new PublicClientApplication(APP_SETTINGS.MSAL_CONFIG);
  msalInstance.setNavigationClient(navigationClient);

  // Get the current theme from Redux store
  const { theme } = useAppSelector((state) => state.theme);

  // Add effect to apply theme class to the HTML element
  useEffect(() => {
    document.documentElement.className = `theme-${theme}`;
  }, [theme]);

  // //clear items selection on lab inventory page
  useEffect(() => {
    dispatch(clearAllSelectedItems());
  }, [location.pathname, dispatch]);

  useEffect(() => {
    if (!location.pathname.startsWith(ROUTES.labInventory.url)) {
      sessionStorage.removeItem(LAB_INVENTORY_GLOBAL_SEARCH_KEY);
    }
  }, [location.pathname]);

  return (
    <div id="demo_app_frame" className={`App-container theme-${theme}`}>
      <Layout>
        <NotificationDialog />
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route
              path={ROUTES["accessDenied"].url}
              element={<AccessDenied />}
            />
            <Route path="/" element={<Navigate to={"/home"} />} />
            <>
              {Object.entries(ROUTES)
                .filter(([key, route], index) => !route.isSubRoute)
                .map(([key, route], index) => {
                  const Component = componentMapping[key];
                  if (Component || key.includes("import")) {
                    return (
                      <Route
                        key={index}
                        path={route.url}
                        element={
                          <RoleBasedRouting
                            Component={
                              key.includes("import") ? (
                                <Import key={key} route={key} />
                              ) : (
                                <Component />
                              )
                            }
                            isRoleBasedRoute={route.isRoleBasedRoute}
                            title={route.title}
                          />
                        }
                      />
                    );
                  } else {
                    return <></>;
                  }
                })}
            </>
          </Routes>
        </Suspense>
      </Layout>
    </div>
  );
};
